<!--//@*/*
//    *RPD Audio APP v0.91
//    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//-->


<template>

        <Transition name="scroll-y-reverse-transition" mode="out-in">

            <v-container class="cmpbk black--text" id="home-container">

                <v-row no-gutters>

                    <v-col id="maincol" cols="12">
                        <div id="rect" style="background-color: white; height:83vh;margin: auto;">
                            <v-expansion-panels v-model="panel">

                                <v-expansion-panel>
                                    <v-expansion-panel-header color="primary" class="white--text">
                                        Dispersal Order
                                        <template v-slot:actions>
                                            <v-icon color="secondary">
                                                $chevup
                                            </v-icon>
                                        </template>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-container>
                                            <v-row dense>
                                                <v-col col="12">
                                                    <v-card elevation="2" outlined>
                                                        <v-card-actions id="actions1_disperse">
                                                            <v-btn rounded color="secondary"
                                                                   @click="btn_play_all()">
                                                                <v-icon left>
                                                                    $play
                                                                </v-icon>
                                                                Play All
                                                            </v-btn>
                                                            <v-btn rounded color="secondary"
                                                                   @click="btn_loop_all()">
                                                                <v-icon left>
                                                                    $loop
                                                                </v-icon>
                                                                Loop All
                                                            </v-btn>
                                                        </v-card-actions>
                                                        <v-card-actions id="actions2_disperse"
                                                                        style="display:none">
                                                            <v-btn rounded color="red" class="white--text"
                                                                   @click="btn_stop_all()">

                                                                <v-icon left>
                                                                    $stop
                                                                </v-icon>
                                                                Stop All
                                                            </v-btn>
                                                            <v-spacer></v-spacer>
                                                            <span class="text-caption">{{looptxt}}</span>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                            <v-row dense
                                                   v-for="afile in audio_files" :key="afile.audio_fileId">
                                                <v-col col="12">
                                                    <v-card elevation="2" outlined :ref="afile.audio_fileId">
                                                        <v-card-title>
                                                            {{afile.lang}}
                                                            <v-spacer></v-spacer>
                                                            <div class="text-caption">
                                                                {{afile.filename}}
                                                            </div>
                                                        </v-card-title>
                                                        <v-card-actions :ref="'cardaction1_' + afile.audio_fileId"
                                                                        :id="'cardaction1_' + afile.audio_fileId">
                                                            <v-btn rounded color="accent"
                                                                   :ref="'play_' + afile.audio_fileId"
                                                                   :id="'play_' + afile.audio_fileId"
                                                                   @click="btn_play(afile.audio_fileId)">
                                                                <v-icon left>
                                                                    $play
                                                                </v-icon>
                                                                Play
                                                            </v-btn>
                                                            <v-btn rounded color="accent"
                                                                   :id="'loop_' + afile.audio_fileId"
                                                                   :ref="'loop_' + afile.audio_fileId"
                                                                   @click="btn_loop(afile.audio_fileId)">

                                                                <v-icon left>
                                                                    $loop
                                                                </v-icon>
                                                                Loop
                                                            </v-btn>
                                                            <v-spacer></v-spacer>
                                                            <v-chip :id="'chip_' + afile.audio_fileId" small color="red" :ref="'chip_' + afile.audio_fileId">
                                                            </v-chip>
                                                        </v-card-actions>
                                                        <v-card-actions style="display:none"
                                                                        :ref="'cardaction2_' + afile.audio_fileId"
                                                                        :id="'cardaction2_' + afile.audio_fileId">
                                                            <v-btn rounded color="red" class="white--text"
                                                                   @click="btn_stop(afile.audio_fileId)"
                                                                   :id="'stop_' + afile.audio_fileId"
                                                                   :ref="'stop_' + afile.audio_fileId">

                                                                <v-icon left>
                                                                    $stop
                                                                </v-icon>
                                                                Stop
                                                            </v-btn>
                                                            <v-spacer></v-spacer>
                                                            <span class="text-caption">{{looptxt}}</span>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-container>

                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <!--<v-expansion-panels v-model="panel">
                            <v-expansion-panel :key="1">
                                <v-expansion-panel-header class="primary white--text">
                                    <template v-slot:default="{ open }">
                                        <div>
                                            <v-icon color="secondary" x-large>
                                                <template v-if="open">
                                                    $chevup
                                                </template>
                                                <template v-else>
                                                    $chevdown
                                                </template>

                                            </v-icon>
                                            <span class="expansion-title">Disperse</span>
                                        </div>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>-->

                        </div>
                    </v-col>
                    <!-- <v-col id="panel1" cols="12" class="col-md-10">
                    <div id="rect" style="background-color:whitesmoke; width: 98%;height:90vh;margin: auto;"></div>
                </v-col> -->
                </v-row>

            </v-container>
        </Transition>

</template>
<style lang="scss" scoped>
    @import "../scss/site.scss";
    #home-container {
        max-width: 768px;
        height: calc(100% - 48px);
    }

</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";

    export default {
        name: 'Home',
        mixins: [bus_common],
        components: {  },
        data() {
            return {
                admin_mode: true,
                nav_val: "apps",
                audio_files: [],
                audio_objs:[],
                panel: 0,
                looptxt: '',
                disperse_curindx:-1,
            };
        },
        watch: {

        },
        methods: {
            btn_stop_all: function () {
                //sound.pause();
                //sound.currentTime = 0;
                this.looptxt = "";
                //this will kill a play or loop all
                let indx = this.disperse_curindx;
                this.disperse_curindx = -1;
                // in case we all palying or looping all and the stop button is hit for one file
                //restore all UI

                document.getElementById("actions2_disperse").style.display = 'none';
                document.getElementById("actions1_disperse").style.display = 'flex';



         
                this.audio_objs[indx].audioElement.pause();
                this.audio_objs[indx].audioElement.currentTime = 0;
                this.audio_objs[indx].loop = false;
                document.getElementById(this.audio_objs[indx].cardaction2).style.display = 'none';
                document.getElementById(this.audio_objs[indx].cardaction1).style.display = 'flex';
                return true;

            },
            btn_loop_all: function (disperse_curindx) {
                let self = this;
                this.looptxt = "LOOP";


                document.getElementById("actions1_disperse").style.display = 'none';
                document.getElementById("actions2_disperse").style.display = 'flex';

                //inti loop
                if (disperse_curindx == null) {
                    this.disperse_curindx = 0;
                }

                let indx = self.disperse_curindx;
                this.audio_objs[indx].audioElement.volume = 1.0;
                this.audio_objs[indx].audioElement.play();
                document.getElementById(this.audio_objs[indx].cardaction1).style.display = 'none';
                document.getElementById(this.audio_objs[indx].cardaction2).style.display = 'flex';

                this.audio_objs[indx].audioElement.onended = function () {
                    //self.btn_stop(self.audio_objs[indx].audio_fileId, true);

                    //file ui
                    document.getElementById(self.audio_objs[indx].cardaction2).style.display = 'none';
                    document.getElementById(self.audio_objs[indx].cardaction1).style.display = 'flex';

                    //all ui
                    document.getElementById("actions2_disperse").style.display = 'none';
                    document.getElementById("actions1_disperse").style.display = 'flex';

                    //if we add one to the current index will it be lss then the length of the array indexs
                    if ((self.disperse_curindx + 1 <= self.audio_objs.length - 1) && self.disperse_curindx != -1) {
                        self.disperse_curindx += 1;
                        self.btn_loop_all(self.disperse_curindx);
                    } else {
                        // here we check for loopyness
                        if (self.disperse_curindx == self.audio_objs.length - 1) {
                            self.disperse_curindx = 0;
                            self.btn_loop_all(self.disperse_curindx);
                        } else {
                            self.disperse_curindx = -1
                        }
                       
                    }
                }
                return true;
            },
            btn_play_all: function (disperse_curindx) {
                let self = this;
                this.looptxt = "";

                
                document.getElementById("actions1_disperse").style.display = 'none';
                document.getElementById("actions2_disperse").style.display = 'flex';

              //inti loop
                if (disperse_curindx == null) {
                    this.disperse_curindx = 0;
                }

                let indx = self.disperse_curindx;
                this.audio_objs[indx].audioElement.volume = 1.0;
                this.audio_objs[indx].audioElement.play();
                document.getElementById(this.audio_objs[indx].cardaction1).style.display = 'none';
                document.getElementById(this.audio_objs[indx].cardaction2).style.display = 'flex';

                this.audio_objs[indx].audioElement.onended = function () {
                    self.btn_stop(self.audio_objs[indx].audio_fileId, true);

                    document.getElementById("actions2_disperse").style.display = 'none';
                    document.getElementById("actions1_disperse").style.display = 'flex';

                    //if we add one to the current index will it be lss then the length of the array indexs
                    if ((self.disperse_curindx + 1 <= self.audio_objs.length - 1) && self.disperse_curindx != -1) {
                        self.disperse_curindx += 1;
                        self.btn_play_all(self.disperse_curindx);
                    } else {
                        self.disperse_curindx = -1
                    }
                }
                return true;
            },
            btn_stop: function (audio_fileId, all_flag) {
                //sound.pause();
                //sound.currentTime = 0;
                this.looptxt = "";
                //this will kill a play or loop all
                if (all_flag != true) {
                    this.disperse_curindx = -1;
                    // in case we all palying or looping all and the stop button is hit for one file
                    //restore all UI

                    document.getElementById("actions2_disperse").style.display = 'none';
                    document.getElementById("actions1_disperse").style.display = 'flex';
                }
             

                let indx = this.audio_objs.findIndex(item => item.audio_fileId === audio_fileId);
                this.audio_objs[indx].audioElement.pause();
                this.audio_objs[indx].audioElement.currentTime = 0;
                this.audio_objs[indx].loop = false;
                document.getElementById(this.audio_objs[indx].cardaction2).style.display = 'none';
                document.getElementById(this.audio_objs[indx].cardaction1).style.display = 'flex';
                return true;
            },
            btn_play: function (audio_fileId) {
                let self = this;
                this.looptxt = "";
                let indx = this.audio_objs.findIndex(item => item.audio_fileId === audio_fileId);
                this.audio_objs[indx].audioElement.volume = 1.0;
                 this.audio_objs[indx].audioElement.play();
                document.getElementById(this.audio_objs[indx].cardaction1).style.display = 'none';
                document.getElementById(this.audio_objs[indx].cardaction2).style.display = 'flex';
                this.audio_objs[indx].audioElement.onended = function () {
                    self.btn_stop(audio_fileId);
                    return true;
                };
                return true;
            },
            btn_loop: function (audio_fileId) {
                let self = this;
                this.looptxt = "LOOP";
                let indx = this.audio_objs.findIndex(item => item.audio_fileId === audio_fileId);
                this.audio_objs[indx].audioElement.volume = 1.0;
                this.audio_objs[indx].audioElement.play();
                this.audio_objs[indx].loop = true;
                document.getElementById(this.audio_objs[indx].cardaction1).style.display = 'none';
                document.getElementById(this.audio_objs[indx].cardaction2).style.display = 'flex';
                this.audio_objs[indx].audioElement.onended = function () {
                    document.getElementById(self.audio_objs[indx].cardaction2).style.display = 'none';
                    document.getElementById(self.audio_objs[indx].cardaction1).style.display = 'flex';
                    if (self.audio_objs[indx].loop == true) {
                        self.btn_loop(audio_fileId);
                        return true;
                    }
                };

            },
            //logout() {
            //    let callback = () => {
            ////        this.$router.replace({ path: "/" });
            //    }
            //    this.swall_diag("Log Out?", "Are you sure you would like to log out?", "question", callback, "Yes", "No", null)
            //}
            create_audio_objects: function(){

                for (var i = 0; i < this.audio_files.length; i++) {
                    //create an undispalyed audio element and set its id for the index that is in the
                    //audio_files arrays and audio_objs, so later we can lsiten for events across th arrays
                    const audioElement = new Audio('/audio/' + this.audio_files[i].filename);
                    audioElement.setAttribute("id", i);
                    this.audio_objs.push({ 'audioElement': audioElement });
                    this.audio_objs[i].index = i;
                    this.audio_objs[i].audio_fileId = this.audio_files[i].audio_fileId;



                    var self = this;
                    this.audio_objs[i].audioElement.addEventListener('loadeddata', (evt) => {
                       // console.log(evt);
                        // now the id can be our index into the arrays
                        const indx = parseInt(evt.target.id);
                        self.audio_objs[indx].ready = true;
                        self.audio_objs[indx].loop = false;

                        //make the chip element more address and add to array
                        self.audio_objs[indx].chipElemId = self.$refs["chip_" + self.audio_files[indx].audio_fileId][0].$attrs["id"];

                        const fileID = self.audio_files[indx].audio_fileId;
                        //add elemts
                        self.audio_objs[indx].playElemId = "play_" + fileID;
                        self.audio_objs[indx].loopElemId = "loop_" + fileID;
                        self.audio_objs[indx].cardaction1 = "cardaction1_" + fileID;
                        self.audio_objs[indx].cardaction2 = "cardaction2_" + fileID;
                        self.audio_objs[indx].stopElemId = "stop_" + fileID;

                        //the audio file is loaded so turn the chip green
                        document.getElementById(self.audio_objs[indx].chipElemId).style.setProperty("background-color", "green", "important");
                  
                    })
                }

            },
            init: function () {
                //Retrieve auido files
                this.show_loader(true);
                var formIn = { email: this.$store.state.user.email,
                     token: this.$store.state.user.token,
                    apiname:'get_audio_files' };

                this.$store
                    .dispatch("anyapi", formIn)
                    .then(data => {
                        //Set record to the new edit person for the modal and open
                        this.audio_files = this.mno(data);
                        this.create_audio_objects();
                        this.show_loader(false);
                    })
                    .catch(msg => {
                        this.show_loader(false);
                        this.swall_it("Error", msg, "error", null, null);
                    });
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
               // console.log("home query: " + this.$route.query.token);
                // The whole view is rendered, so I can safely access or query
                // the DOM. ¯\_(ツ)_/¯
            })

    }
}
</script>


